import { AfterViewInit, Directive, ElementRef, Input } from "@angular/core";
@Directive({
    selector: "[embedHTML]"
})
export class EmbedHTMLDirective implements AfterViewInit {
    @Input('embedHTML') htmlContent: string;

    constructor(private elementRef: ElementRef) {

    }
    ngAfterViewInit(): void {
        this.displayInnerHtml();
    }

    /**
     * @description creating the shadow dom and appending the Html content.
     * @author Akhil
     * @date 2020-04-22
     * @memberof EmbedHTMLDirective
     */
    private displayInnerHtml(): void {
        if (this.htmlContent) {
            this.htmlContent = this.processHtmlContent(this.htmlContent);
        }
        const element = this.elementRef.nativeElement;
        if (element) {
            if (this.isEdgeBrowser()) {
                element.innerHTML = this.htmlContent;
            }
            else {
                element.attachShadow({ mode: 'open' });
                element.shadowRoot.innerHTML = this.htmlContent;
            }
        }

    }
    /**
     * @description checking edge browser presence in the userAgent
     * @author Akhil
     * @date 2020-04-22
     * @memberof EmbedHTMLDirective
     */
    isEdgeBrowser() {
        const agent = window.navigator.userAgent.toLowerCase();
        const isEdgeBrowser = agent.indexOf('edge') > -1
        return isEdgeBrowser;
    }
     /**
     * @description Processing the html content to append styles and scripts
     * @author saravanan
     * @date 2020-05-19
     * @memberof EmbedHTMLDirective
     */
    processHtmlContent(htmlContent: string): string {
        if (htmlContent) {
            const styles = this.getStyles();
            htmlContent = htmlContent + styles;
        }
        if (htmlContent.includes(`style="mso-margin-top-alt:auto;mso-margin-bottom-alt:auto"`)) {
            htmlContent = htmlContent.replace(`style="mso-margin-top-alt:auto;mso-margin-bottom-alt:auto"`,`style="margin-top:10px"`);
        }
        return htmlContent;
    }

    /**
     * @description Getting Styles for the html content
     * @author saravanan
     * @date 2020-05-19
     * @memberof EmbedHTMLDirective
     */
    getStyles(): string {
        const styles = `<style>
                        pre{
                            white-space:pre-line;
                        }
                        div {
                            line-height: 1.5 !important;
                        }
                       </style>`;
        return styles;
    }

}



// WEBPACK FOOTER //
// ./src/app/common/directives/embed-Html.directive.ts